{
  "a": {
    "type": "vowel",
    "glyph": "अ",
    "matra": ""
  },
  "ā": {
    "type": "vowel",
    "glyph": "आ",
    "matra": "ा"
  },
  "aa": {
    "type": "vowel",
    "glyph": "आ",
    "matra": "ा"
  },
  "ai": {
    "type": "vowel",
    "glyph": "ऐ",
    "matra": "ै"
  },
  "au": {
    "type": "vowel",
    "glyph": "औ",
    "matra": "ौ"
  },
  "ba": {
    "type": "consonant",
    "glyph": "ब"
  },
  "bha": {
    "type": "consonant",
    "glyph": "भ"
  },
  "ca": {
    "type": "consonant",
    "glyph": "च"
  },
  "cha": {
    "type": "consonant",
    "glyph": "छ"
  },
  "da": {
    "type": "consonant",
    "glyph": "द"
  },
  "Da": {
    "type": "consonant",
    "glyph": "ड"
  },
  "dha": {
    "type": "consonant",
    "glyph": "ध"
  },
  "Dha": {
    "type": "consonant",
    "glyph": "ढ"
  },
  "e": {
    "type": "vowel",
    "glyph": "ए",
    "matra": "े"
  },
  "fa": {
    "type": "consonant",
    "glyph": "फ़"
  },
  "ga": {
    "type": "consonant",
    "glyph": "ग"
  },
  "gha": {
    "type": "consonant",
    "glyph": "घ"
  },
  "ḥ": {
    "type": "mark",
    "glyph": "ः"
  },
  "ha": {
    "type": "consonant",
    "glyph": "ह"
  },
  "i": {
    "type": "vowel",
    "glyph": "इ",
    "matra": "ि"
  },
  "ī": {
    "type": "vowel",
    "glyph": "ई",
    "matra": "ी"
  },
  "ii": {
    "type": "vowel",
    "glyph": "ई",
    "matra": "ी"
  },
  "ja": {
    "type": "consonant",
    "glyph": "ज"
  },
  "jha": {
    "type": "consonant",
    "glyph": "झ"
  },
  "jña": {
    "type": "conjunct",
    "glyph": "ज्ञ"
  },
  "ka": {
    "type": "consonant",
    "glyph": "क"
  },
  "kha": {
    "type": "consonant",
    "glyph": "ख"
  },
  "kṣa": {
    "type": "conjunct",
    "glyph": "क्ष"
  },
  "ḷ": {
    "type": "vowel",
    "glyph": "ऌ",
    "matra": "ॢ"
  },
  "la": {
    "type": "consonant",
    "glyph": "ल"
  },
  "ṁ": {
    "type": "mark",
    "glyph": "ं"
  },
  "ṃ": {
    "type": "mark",
    "glyph": "ं"
  },
  "ma": {
    "type": "consonant",
    "glyph": "म"
  },
  "na": {
    "type": "consonant",
    "glyph": "न"
  },
  "Na": {
    "type": "consonant",
    "glyph": "ण"
  },
  "ña": {
    "type": "consonant",
    "glyph": "ञ"
  },
  "ṅa": {
    "type": "consonant",
    "glyph": "ङ"
  },
  "o": {
    "type": "vowel",
    "glyph": "ओ",
    "matra": "ो"
  },
  "pa": {
    "type": "consonant",
    "glyph": "प"
  },
  "pha": {
    "type": "consonant",
    "glyph": "फ"
  },
  "qa": {
    "type": "consonant",
    "glyph": "क़"
  },
  "ṛ": {
    "type": "vowel",
    "glyph": "ऋ",
    "matra": "ृ"
  },
  "ṝ": {
    "type": "vowel",
    "glyph": "ॠ",
    "matra": "ॄ"
  },
  "ra": {
    "type": "consonant",
    "glyph": "र"
  },
  "ṛa": {
    "type": "consonant",
    "glyph": "ड़"
  },
  "ṛha": {
    "type": "consonant",
    "glyph": "ढ़"
  },
  "ri": {
    "type": "vowel",
    "glyph": "ऋ",
    "matra": "ृ"
  },
  "sa": {
    "type": "consonant",
    "glyph": "स"
  },
  "śa": {
    "type": "consonant",
    "glyph": "श"
  },
  "ṣa": {
    "type": "consonant",
    "glyph": "ष"
  },
  "śra": {
    "type": "conjunct",
    "glyph": "श्र"
  },
  "ta": {
    "type": "consonant",
    "glyph": "त"
  },
  "Ta": {
    "type": "consonant",
    "glyph": "ट"
  },
  "tha": {
    "type": "consonant",
    "glyph": "थ"
  },
  "Tha": {
    "type": "consonant",
    "glyph": "ठ"
  },
  "u": {
    "type": "vowel",
    "glyph": "उ",
    "matra": "ु"
  },
  "ū": {
    "type": "vowel",
    "glyph": "ऊ",
    "matra": "ू"
  },
  "uu": {
    "type": "vowel",
    "glyph": "ऊ",
    "matra": "ू"
  },
  "va": {
    "type": "consonant",
    "glyph": "व"
  },
  "ya": {
    "type": "consonant",
    "glyph": "य"
  },
  "za": {
    "type": "consonant",
    "glyph": "ज़"
  }
}
